module.exports = __webpack_public_path__ + "4e3992623756ff10b9065884d2f78330.png";